<template>
  <div>
    <p class="title">帮助中心-{{isNew?"新增文章":"编辑文章"}}</p>
    <zt-button type="primary" @click="back" size="mini" class="btn">返回</zt-button>
    <el-input v-model="title" class="input" placeholder="标题"></el-input>
    <quill-editor ref="quillDetail" v-model="content" :options="editorOption"></quill-editor>
    <div class="radio">
      <span>是否置顶：</span>
      <el-radio-group v-model="top">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
    </div>
    <zt-button type="primary" @click="submit" class="sub-btn">提交</zt-button>
  </div>
</template>

<script>
// 富文本编辑器
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import { editorOption } from './quillconfig';
import { uploadImage } from '@/api/upload';
import {
  taoke_cms_help_edit,
  taoke_cms_help_add,
  taoke_cms_help_order_set_top,
  taoke_cms_help_order_set_notop
} from '@/api/article';

export default {
  name: 'articleEdit',
  components: {
    quillEditor,
  },
  data: () => ({
    top:true,
    editorOption,
    content: '',
    title: '',
  }),
  props: {
    article: Object,
    isNew: Boolean,
  },
  computed:{
    
  },
  methods: {
    uploadImage(state) {
      const input = document.createElement('input');
      const that = this;
      input.type = 'file';
      input.accept = 'image/png, image/jpeg';
      input.className = 'ql-image-input';
      input.style = 'display:none;';
      document.querySelector('.ql-container.ql-snow').appendChild(input);
      let fileinput = this.$refs.quillDetail.quill.container.querySelector(
        'input.ql-image-input[type=file]'
      );
      if (state) {
        fileinput.click();
      }
      fileinput.removeEventListener('change', that.quillChange);
      fileinput.addEventListener('change', that.quillChange);
    },
    quillChange() {
      // 上传图片
      let that = this;
      let fileinput = this.$refs.quillDetail.quill.container.querySelector(
        'input.ql-image-input[type=file]'
      );

      uploadImage(fileinput.files[0]).then(({ data }) => {
        // 上传成功返回图片路径
        that.addImageInQuill(data.file);
      });
    },
    addImageInQuill(url) {
      // 图片上传成功后，向富文本插入图片
      // 获取光标位置对象，里面有两个属性，一个是index 还有 一个length，这里要用range.index，即当前光标之前的内容长度，然后再利用 insertEmbed(length, 'image', imageUrl)，插入图片即可。
      let addRange = this.$refs.quillDetail.quill.getSelection();
      // 调用编辑器的 insertEmbed 方法，插入URL
      this.$refs.quillDetail.quill.insertEmbed(
        addRange !== null ? addRange.index : 0,
        'image',
        url,
        Quill.sources.USER
      );
    },
    //提交置顶
    toTop(id) {
      if (this.top) {
        taoke_cms_help_order_set_top({ id: id }).then((res) => {
          if (res.data.error_code != 0) {
            this.$message.error(res.data.error_message);
          }
        });
      }
    },
    //取消置顶
    replaceTop(id) {
      taoke_cms_help_order_set_notop({ id: id })
    },
    //提交
    submit() {
      if (this.isNew) {
        taoke_cms_help_add({
          title: this.title,
          content: this.content,
        }).then((res) => {
          if (res.data.error_code == 0) {
            //添加新文章获取id判断置顶
            if (this.top) {
              this.toTop(res.data.id);
            }
            this.$message.success('添加文章成功');
            this.$emit('back');
          } else {
            this.$message.error(res.data.error_message);
          }
        });
      } else {
        taoke_cms_help_edit({
          id: this.article.id,
          title: this.title,
          content: this.content,
        }).then((res) => {
          if (res.data.error_code == 0) {
            //针对第一篇文章
            if (!this.top&&this.article.order_id==1) {
              this.replaceTop(this.article.id)
            }
            this.toTop(this.article.id);
            this.$message.success('修改文章成功');
            this.$emit('back');
          } else {
            this.$message.error(res.data.error_message);
          }
        });
      }
    },
    back() {
      this.$confirm('是否退出当前页面', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.$emit('back');
          console.log('退出');
        })
        .catch(() => {
          console.log('取消');
        });
    },
  },
  mounted() {
    if (this.isNew) {
      this.content = '';
      this.title = '';
    } else {
      this.content = this.article.content;
      this.title = this.article.title;
    }
    this.top=this.article.order_id==1
    this.$refs.quillDetail.quill
      .getModule('toolbar')
      .addHandler('image', this.uploadImage);
  },
};
</script>

<style lang="scss" scoped>
.title{
  font-weight: 600
}
.btn {
  margin-top: 20px;
}
.input /deep/ .el-input__inner {
  display: inline-block;
  margin-top: 20px;
  border-style: solid;
  border-width: 0px 0px 1px 0px;
  font-size: 16px;
}
#edit {
  margin-top: 20px;
}
.radio {
  margin-top: 40px;
  span {
    font-size: 14px;
    margin-right: 40px;
  }
}
.sub-btn {
  width: 150px;
  margin-top: 20px;
}
/deep/ .ql-container {
  min-height: 400px;
  max-height: 500px;
  overflow: auto;
}
</style>


